import VerbatimManagement from './verbatimManagement'
export default VerbatimManagement
